// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Y6XT","notes":"Notes_notes__2nac2","note":"Notes_note__2P3uz","markdown":"Notes_markdown__2cMrE"};